import { inputTextLimit } from '../../../../helpers/fieldRestriction';
import messages from '../../../../locale/jsonMessages';

const validate = values => {

  const errors = {}

  if (!values?.smtpName || values?.smtpName.toString().trim() == "") errors.smtpName = messages.required;
  else if (values?.smtpName?.length > inputTextLimit) errors.smtpName = messages.inputTextLimitError;

  if (!values?.smtpHost || values?.smtpHost.toString().trim() == "") errors.smtpHost = messages.required;
  else if (values?.smtpHost?.length > inputTextLimit) errors.smtpHost = messages.inputTextLimitError;

  if (!values?.smtpPort || values?.smtpPort.toString().trim() == "") errors.smtpPort = messages.required;
  if (values?.smtpPort && isNaN(values?.smtpPort)) errors.smtpPort = messages.onlyNumericKey;
  if (values?.smtpPort?.length > inputTextLimit) errors.smtpPort = messages.inputTextLimitError;

  if (!values?.smtpEmail || values?.smtpEmail.toString().trim() == "") errors.smtpEmail = messages.required;
  else if (values?.smtpEmail?.length > inputTextLimit) errors.smtpEmail = messages.inputTextLimitError;

  if (!values?.smtpSender || values?.smtpSender.toString().trim() == "") errors.smtpSender = messages.required;
  else if (values?.smtpSender?.length > inputTextLimit) errors.smtpSender = messages.inputTextLimitError;

  if (!values?.smtpPassword || values?.smtpPassword.toString().trim() == "") errors.smtpPassword = messages.required;
  else if (values?.smtpPassword?.length > inputTextLimit) errors.smtpPassword = messages.inputTextLimitError;

  if (!values?.smtpSenderEmail) {
    errors.smtpSenderEmail = messages.required;
  } else if (!values?.isEncrypt && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(values?.smtpSenderEmail)) {
    errors.smtpSenderEmail = messages.emailInvalid;
  }
  return errors
}

export default validate